import { render, staticRenderFns } from "./ShareProfilesDialog.vue?vue&type=template&id=63e45075&"
import script from "./ShareProfilesDialog.vue?vue&type=script&lang=js&"
export * from "./ShareProfilesDialog.vue?vue&type=script&lang=js&"
import style0 from "./ShareProfilesDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports